// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Do-z","badgeLink":"Eo-z","category":"Fo-z"};